import { globalConstants, USER_CONSTANTS } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  loginData: {},
  profileData: {}
};
//Manipulating the state of admin portal based on actions and returning the state
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_CONSTANTS.LOGIN + SUCCESS:
      return { ...state, loginData: action.data };
    case USER_CONSTANTS.PROFILE_DATA + SUCCESS:
      return { ...state, profileData: action.data };
    default:
      return state;
  }
};
